import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useState } from "react";
import { styled } from "@mui/material";

function a11yProps(id: string) {
  return {
    id: `users-group-tab-${id}`,
    "aria-controls": `users-group-tabpanel-${id}`,
  };
}

type Props = {
  tabs: {
    id: string;
    label: string;
    icon?: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
    panel: React.ReactNode;
  }[];
};

const StyledTab = styled(Tab)(({ theme }) => ({
  color: theme.palette.text.primary,
  textTransform: "capitalize",
  padding: "0.5rem",
  minHeight: "0",
  fontWeight: "600",
  minWidth: "0",
  "&:not(:first-child)": {
    marginLeft: "8px",
  },
}));

export default function UserGroupsTabs({ tabs }: Props) {
  const [active, setActive] = useState(tabs[0].id);

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    setActive(newValue);
  };
  return (
    <Box sx={{ width: "100%" }}>
      <Box>
        <Tabs
          value={active}
          onChange={handleChange}
          sx={{ minHeight: "0" }}
          TabIndicatorProps={{ style: { display: "block" } }}
        >
          {tabs.map((tab) => (
            <StyledTab
              key={tab.id}
              value={tab.id}
              iconPosition="start"
              icon={tab.icon}
              label={tab.label}
              {...a11yProps(tab.id)}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tab) => (
        <div
          key={tab.id}
          role="tabpanel"
          hidden={active !== tab.id}
          id={`users-group-tabpanel-${tab.id}`}
          aria-labelledby={`users-group-tab-${tab.id}`}
        >
          {active === tab.id && (
            <Box sx={{ marginTop: "24px" }}>{tab.panel}</Box>
          )}
        </div>
      ))}
    </Box>
  );
}
